module.exports = __webpack_public_path__ + "static/media/Daredevil.f51b4d22.png";